import { ActionTypes, Actions } from '@appStore/contracts/actions';
import { Contract, Agreement, ContractSettings, AdditionEsignData, AgreementAdditionExclusion } from '@model';

export interface State {
  contractLoaded: boolean;
  contractLoading: boolean;
  selectedContract: Contract;

  contractsForDateIntervalLoaded: boolean;
  contractsForDateIntervalLoading: boolean;
  contractsForDateInterval: Contract[];

  contractsLoaded: boolean;
  contractsLoading: boolean;
  contracts: Contract[];

  contractsFilter: ContractSettings;

  agreementProductsLoaded: boolean;
  agreementProductsLoading: boolean;
  agreementProducts: Agreement[];

  tabSelected: number;
  selectedColdPageIndex: number;
  selectedHotPageIndex: number;
  selectedPageSizeHot: number;
  selectedPageSizeCold: number;
  sortColumnHot: string;
  sortColumnCold: string;
  sortDirectionHot: string;
  sortDirectionCold: string;
  scrollPositionHot: [number, number];
  scrollPositionCold: [number, number];

  selectedTabIndexContract: number;
  hasContractAdditions: boolean;
  hasContractAdditionsLoading: boolean;
  hasContractAdditionsLoaded: boolean;

  agreementAdditionEsign: AdditionEsignData[];
  agreementAdditionEsignLoading: boolean;
  agreementAdditionEsignLoaded: boolean;

  additionProductExclusions: AgreementAdditionExclusion[];
  additionProductExclusionsLoading: boolean;
  additionProductExclusionsLoaded: boolean;
}

export const initialState: State = {
  contractLoaded: false,
  contractLoading: false,
  selectedContract: null,

  contractsForDateIntervalLoaded: false,
  contractsForDateIntervalLoading: false,
  contractsForDateInterval: [],

  contractsLoaded: false,
  contractsLoading: false,
  contracts: [],

  contractsFilter: null,

  agreementProductsLoaded: false,
  agreementProductsLoading: false,
  agreementProducts: [],

  tabSelected: 0,
  selectedColdPageIndex: 0,
  selectedHotPageIndex: 0,
  selectedPageSizeCold: 25,
  selectedPageSizeHot: 25,
  sortColumnHot: 'meteringPointId',
  sortColumnCold: 'meteringPointId',
  sortDirectionHot: 'desc',
  sortDirectionCold: 'desc',
  scrollPositionHot: [0, 0],
  scrollPositionCold: [0, 0],

  selectedTabIndexContract: 0,

  hasContractAdditions: false,
  hasContractAdditionsLoading: false,
  hasContractAdditionsLoaded: false,

  agreementAdditionEsign: [],
  agreementAdditionEsignLoading: false,
  agreementAdditionEsignLoaded: false,

  additionProductExclusions: [],
  additionProductExclusionsLoading: false,
  additionProductExclusionsLoaded: false,
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    // Contract
    case ActionTypes.ContractLoadData:
      return { ...state, contractLoaded: false, contractLoading: true, selectedContract: null };
    case ActionTypes.ContractLoadDataSuccess:
      let existingItem = state.contracts.find(contract => contract.id === action.payload.id);
      let newList = [...state.contracts];
      let selectedItem = { ...action.payload, isFullObject: true };

      // If the item already exists - then change it for the new one
      if (existingItem) {
        newList = newList.map(contract => {
          let resultItem = contract;

          // Overwrite the small item with the big item. Some values need to be copied
          if (contract.id === action.payload.id) {
            selectedItem.prognosis = contract.prognosis;

        
            selectedItem.additionalProducts = selectedItem.additionalProducts.map(sap => {
              let resultingAddition = sap;
              let contractAddition = null;
              if (!resultingAddition.sublevelName) {
                contractAddition = contract.additionalProducts.find(cap => cap.code === sap.code);
              } else {
                contractAddition = contract.additionalProducts.find(
                  cap => cap.code === sap.code && cap.sublevelName === sap.sublevelName
                );
              }
              if (contractAddition && contractAddition.sublevel) {
                resultingAddition = {
                  ...sap,
                  sublevel: contractAddition.sublevel,
                  subComponents: sap.subComponents.map(sc => {
                    return sc + '_' + contractAddition.sublevel;
                  })
                };
              }
              return resultingAddition;
            });

            // Justera tillval som har en sublevel och subcomponent ex Miljöcert i newContract
            if(selectedItem.newContract && selectedItem.newContract.additionalProducts) {

           
              selectedItem.newContract = {
                ...selectedItem.newContract,
                additionalProducts:   selectedItem.newContract.additionalProducts.map(sap => {
               
                  let resultingNewAddition = sap;
                  
                   if (resultingNewAddition && resultingNewAddition.sublevel) {
                     resultingNewAddition = {
                       ...sap,
                       sublevel: resultingNewAddition.sublevel,
                       subComponents: sap.subComponents.map(sc => {
                         return sc + '_' + resultingNewAddition.sublevel;
                       })
                     };
                   }
                   return resultingNewAddition;
                 })
              }
            }

            resultItem = selectedItem;
          }

          return resultItem;
        });
      } else {
        newList.push(selectedItem);
      }

      return {
        ...state,
        contractLoaded: true,
        contractLoading: false,
        contracts: newList
      };
    case ActionTypes.ContractLoadDataFail:
      return { ...state, contractLoaded: false, contractLoading: false };

    // Contract for given Period
    case ActionTypes.ContractForDateIntervalLoadData:
      return { ...state, contractsForDateIntervalLoaded: false, contractsForDateIntervalLoading: true};
    case ActionTypes.ContractForDateIntervalLoadDataSuccess:
    
      return {
        ...state,
        contractsForDateIntervalLoaded: true,
        contractsForDateIntervalLoading: false,
        contractsForDateInterval: action.payload
      };
    case ActionTypes.ContractForDateIntervalLoadDataFail:
      return { ...state, contractsForDateIntervalLoaded: false, contractsForDateIntervalLoading: false };

    // Contract set selected
    case ActionTypes.ContractSetSelected:
      return {
        ...state,
        contractLoaded: true,
        contractLoading: false,
        selectedContract:
          state.selectedContract && state.selectedContract.id === action.payload
            ? state.selectedContract
            : state.contracts.find(contract => contract.id === action.payload)
    };

    case ActionTypes.SelectTabIndexContract:
      return {...state, selectedTabIndexContract: action.payload };

    // Contracts
    case ActionTypes.ContractsLoadData:
      return { ...state, contractsLoaded: false, contractsLoading: true };
    case ActionTypes.ContractsLoadDataSuccess:
      let resultItems = action.payload;
      return {
        ...state,
        contractsLoaded: true,
        contractsLoading: false,
        contracts: resultItems.map(item => {
          let oldItem = state.contracts.find(c => c.id === item.id);
          let newItem = { ...oldItem, ...item };

          newItem.isFullObject = oldItem && oldItem.isFullObject ? true : false;
          return newItem;
        })
      };
    case ActionTypes.ContractsLoadDataFail:
      return { ...state, contractsLoaded: false, contractsLoading: false };

    // Contracts filter
    case ActionTypes.ContractsFilterSaveData:
      return { ...state, contractsFilter: action.payload };

    // Agreement products
    case ActionTypes.AgreementProductsLoadData:
      return { ...state, agreementProductsLoaded: false, agreementProductsLoading: true };
    case ActionTypes.AgreementProductsLoadDataSuccess:
      return {
        ...state,
        agreementProductsLoaded: true,
        agreementProductsLoading: false,
        agreementProducts: action.payload
      };
    case ActionTypes.ContractsLoadDataFail:
      return { ...state, agreementProductsLoaded: false, agreementProductsLoading: false };

    // (Agreement) Addition product exclusions
    case ActionTypes.AgreementAdditionProductExclusionsLoadData:
      return { ...state, additionProductExclusionsLoaded: false, additionProductExclusionsLoading: true };
    case ActionTypes.AgreementAdditionProductExclusionsLoadDataSuccess:
      return {
        ...state,
        additionProductExclusionsLoaded: true,
        additionProductExclusionsLoading: false,
        additionProductExclusions: action.payload
      };
    case ActionTypes.AgreementAdditionProductExclusionsLoadDataFail:
      return { ...state, additionProductExclusionsLoaded: false, additionProductExclusionsLoading: false };

    case ActionTypes.ContractClearData:
      return {
        ...state,
        contractLoaded: false,
        contractLoading: false,
        selectedContract: null,

        contractsLoaded: false,
        contractsLoading: false,
        contracts: [],

        contractsFilter: null,

        agreementProductsLoaded: false,
        agreementProductsLoading: false,
        agreementProducts: []
      };

    case ActionTypes.ContractTabChanged:
      return { ...state, tabSelected: action.payload };

    case ActionTypes.ContractSelectedColdPageIndex:
      return {
        ...state,
        selectedColdPageIndex: action.pageIndex,
        selectedPageSizeCold: action.pageSize,
        sortColumnCold: action.sortColumn,
        sortDirectionCold: action.sortDirection,
        scrollPositionCold: action.scrollPosition
      };

    case ActionTypes.ContractSelectedHotPageIndex:
      return {
        ...state,
        selectedHotPageIndex: action.pageIndex,
        selectedPageSizeHot: action.pageSize,
        sortColumnHot: action.sortColumn,
        sortDirectionHot: action.sortDirection,
        scrollPositionHot: action.scrollPosition
      };

      case ActionTypes.HasContractAdditions:
        return { ...state, hasContractAdditionsLoaded: false, hasContractAdditionsLoading: true, hasContractAdditions: false };
      case ActionTypes.HasContractAdditionsSuccess:
          return { ...state, hasContractAdditionsLoaded: true, hasContractAdditionsLoading: false, hasContractAdditions: action.payload };
      case ActionTypes.HasContractAdditionsFail:
        return { ...state, hasContractAdditionsLoaded: false, hasContractAdditionsLoading: false };

      case ActionTypes.AgreementAdditionEsignLoad:
        return { ...state, agreementAdditionEsign: [], agreementAdditionEsignLoaded: false, agreementAdditionEsignLoading: true };
      case ActionTypes.AgreementAdditionEsignLoadSuccess:
        return { ...state, agreementAdditionEsign: action.payload, agreementAdditionEsignLoaded: true, agreementAdditionEsignLoading: false };
      case ActionTypes.AgreementAdditionEsignLoadFail:
        return { ...state, agreementAdditionEsign: [], agreementAdditionEsignLoaded: false, agreementAdditionEsignLoading: false };
  }

  return state;
}

export const _getContracts = (state: State) => state.contracts;
export const _getContractsLoaded = (state: State) => state.contractsLoaded;
export const _getContractsLoading = (state: State) => state.contractsLoading;

export const _getContractLoaded = (state: State) => state.contractLoaded;

export const _getContractsForDateInterval = (state: State) => state.contractsForDateInterval;
export const _getContractsForDateIntervalLoaded = (state: State) => state.contractsForDateIntervalLoaded;

export const _getContractsFilter = (state: State) => state.contractsFilter;
export const _getSelectedTabIndexContract = (state: State) => state.selectedTabIndexContract;

export const _getAgreementProducts = (state: State) => state.agreementProducts;
export const _getAgreementProductsLoaded = (state: State) => state.agreementProductsLoaded;
export const _getAgreementProductsLoading = (state: State) => state.agreementProductsLoading;

export const _getAgreementAdditionProductExclusions = (state: State) => state.additionProductExclusions;
export const _getAgreementAdditionProductExclusionsLoaded = (state: State) => state.additionProductExclusionsLoaded;
export const _getAgreementAdditionProductExclusionsLoading = (state: State) => state.additionProductExclusionsLoading;

export const getCustomerSelectedTab = (state: State) => state.tabSelected;
export const _getSelectedColdPageIndex = (state: State) => {
  return {
    pageIndex: state.selectedColdPageIndex,
    pageSize: state.selectedPageSizeCold,
    sortDirection: state.sortDirectionCold,
    sortColumn: state.sortColumnCold,
    scrollPosition: state.scrollPositionCold
  };
};
export const _getSelectedHotPageIndex = (state: State) => {
  return {
    pageIndex: state.selectedHotPageIndex,
    pageSize: state.selectedPageSizeHot,
    sortDirection: state.sortDirectionHot,
    sortColumn: state.sortColumnHot,
    scrollPosition: state.scrollPositionHot
  };
};
export const _getHasContractAdditions = (state: State) => state.hasContractAdditions;
export const _getHasContractAdditionsLoaded = (state: State) => state.hasContractAdditionsLoaded;

export const _getAgreementAdditionEsign = (state: State) => state.agreementAdditionEsign;
export const _getAgreementAdditionEsignLoaded = (state: State) => state.agreementAdditionEsignLoaded;

// export const _getProductSubscriptions = (state: State, meteringPointId: number) => state.productSubscriptions[meteringPointId];
// export const _getProductSubscriptionsLoaded = (state: State, meteringPointId: number) => state.productSubscriptionsLoaded[meteringPointId];
